import type { EditableRow } from '../types';

export function addRowToList(
  list: EditableRow[],
  row: EditableRow
): EditableRow[] {
  return [...list, row];
}

export function removeRowById(list: EditableRow[], id: string): EditableRow[] {
  return list.filter(r => r.id !== id);
}

export function replaceRowInList(
  list: EditableRow[],
  id: string,
  next: EditableRow
): EditableRow[] {
  return list.map(r => (r.id === id ? next : r));
}
